module.exports = __webpack_public_path__ + "r-v3/img/logo_gooroomee_white.2ddc23b1.svg";